import { render, staticRenderFns } from "./PazarStandard.vue?vue&type=template&id=6c1ed569"
import script from "./PazarStandard.vue?vue&type=script&lang=js"
export * from "./PazarStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports